import { connect } from "react-redux";

import { CompanyBusinessRelationshipsComponent } from "./CompanyBusinessRelationships";

export const CompanyBusinessRelationships = connect()(CompanyBusinessRelationshipsComponent);
